// ProductDetails.js
import React from 'react';

const ProductDetails = ({ product }) => (
  <div>
    {product ? (
      <>
        <div>
          <strong>Name:</strong> {product.name}
        </div>
        <div>
          <img src={`http://localhost:3000/${product.image}`} className="w-24 h-24 md:h-10 object-cover mb-2 rounded-r-2xl" alt="Product" />
        </div>
        <div>
          <strong>Price:</strong> {product.price}
        </div>
        <div>
          <strong>Description:</strong> {product.description}
        </div>
        
      </>
    ) : (
      <div>No product details available</div>
    )}
  </div>
);

export default ProductDetails;
